import { render } from "./AttributesGroupTable.vue?vue&type=template&id=1d0aff80"
import script from "./AttributesGroupTable.vue?vue&type=script&lang=js"
export * from "./AttributesGroupTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__